import React, { useState, useEffect } from "react"
import _get from "lodash/get"
import { NumericFormat } from "react-number-format"
import QuantitySelector from "@/components/cart/QuantitySelector"
import CartServiceIcon from "@/public/icons/install-service-cart-icon.svg"
import {
  breakBundleItem,
  getInventoryErrorMessage,
  getInventoryStatus,
  removeCartItem,
} from "@/components/cart/cartHelper"
import styles from "./index.module.scss"
import { checkStock } from "@/utils/helper"

const InstallationServiceCart = ({
  data = {},
  currencySign,
  i18n,
  productQuantity,
  onQuantityChange,
  loading,
  productData,
  checkoutMode,
  orderMode,
  mode,
  inventoryData = {},
}) => {
  const [quantity, setQuantity] = useState()
  const { isBundleChildItem, quantity: bundleInstallationQty } = data

  const [error, setError] = useState({})
  useEffect(() => {
    const {
      nonDeliverableData = [],
      outOfStockData = [],
      installationServiceData = [],
    } = inventoryData
    let isError = false
    let msg
    if (
      nonDeliverableData?.length ||
      outOfStockData?.length ||
      installationServiceData?.length
    ) {
      const status = getInventoryStatus(data, inventoryData, true)
      if (status) {
        isError = true
        msg = getInventoryErrorMessage(status, i18n, true)
      }
    }
    setError({
      isError,
      msg,
    })
  }, [inventoryData])

  useEffect(() => {
    setQuantity(
      isBundleChildItem
        ? bundleInstallationQty
        : productData?.custom?.fields?.associatedServiceQty
    )
  }, [productData, data])

  const MRPPrice = data?.prices?.find(price => !price.customerGroup)

  const handleChange = async qty => {
    setQuantity(qty)
    await onQuantityChange(
      data?.sku,
      qty,
      false,
      data?.masterVariantKey,
      checkStock(data.backOrder, data.category),
      () => {},
      productData,
      data?.id
    )
  }
  const unitPrice = Number(data.discountPrice)
    ? data.discountPrice
    : data.unitPrice

  const price = quantity * unitPrice

  return (
    <div className={styles.installServiceCart}>
      <div className="row install-service-block">
        <div className="col-12 col-sm-12 col-md-6 install-sku-details pl-0">
          <div className="install-service-icon">
            <img src={CartServiceIcon.src} alt="Installation Service" />
          </div>
          <div className="install-service-content">
            <div className="title">
              Installation Service For SKU <span>{productData?.sku}</span>
            </div>
            {data.name && <div className="description">{data.desc}</div>}
            {data.quantity && (
              <div className="description">Qty: {data.quantity}</div>
            )}
            {MRPPrice && (!checkoutMode || mode === "share") ? (
              <div className="mrp mt-10">
                <span>MRP: </span>
                <NumericFormat
                  className=""
                  value={Number(MRPPrice.value.centAmount / 100).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                  thousandsGroupStyle={"lakh"}
                  prefix={currencySign}
                  decimalScale={2}
                />
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-6 install-qty-price">
          <div className="col-5  cart-item__discount-container discount-container-padding">
            {!checkoutMode || mode === "share" ? (
              <NumericFormat
                className="cart-item__total-price hide-mobile-price pr-5"
                aria-description={i18n.unitPrice}
                value={
                  data.discountPrice > 0 ? data.discountPrice : data.unitPrice
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
              />
            ) : null}
          </div>
          <div className="col-3 cart-item__qty px-0">
            {!checkoutMode ? (
              <QuantitySelector
                size="small"
                value={quantity}
                onChange={handleChange}
                loading={loading}
                productQuantity={productQuantity}
                setQuantity={setQuantity}
              />
            ) : null}
            {mode === "share" && (
              <p
                className={`cart-item__${
                  checkoutMode ? "qty_label" : "quantity-price"
                }`}
              >
                <span className="--count">{`${data.quantity}`}</span>
              </p>
            )}
          </div>
          {!checkoutMode || mode === "share" ? (
            <div className="install-service-price col-4">
              <NumericFormat
                className="total-price"
                aria-description={i18n.total}
                value={price}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
              />
              {data.discountPrice > 0 && !isBundleChildItem && (
                <div className="cart-item-qty-container">
                  <NumericFormat
                    className="cart-item__span  car-total-qty-desktop"
                    value={(data.unitPrice * data.quantity).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    thousandsGroupStyle={"lakh"}
                  />
                </div>
              )}
              {data.discountPrice > 0 && !isBundleChildItem && (
                <NumericFormat
                  className="cart-item__span  car-total-qty-mobile"
                  value={(data.unitPrice * data.quantity).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                  thousandsGroupStyle={"lakh"}
                  prefix={currencySign}
                  decimalScale={2}
                />
              )}

              {!orderMode && data.discountPrice > 0 && !isBundleChildItem && (
                <div
                  className={
                    orderMode
                      ? "cart-item__display-discount-order"
                      : !checkoutMode
                      ? "cart-item__display-discount-cart"
                      : "cart-item__display-discount"
                  }
                  aria-label={`Striked price`}
                  aria-required="true"
                  aria-invalid="false"
                >
                  <div
                    className={
                      orderMode
                        ? "cart-item__discount-price --offPercentage"
                        : !checkoutMode
                        ? "cart-item__discount-price --offPercentCart"
                        : "cart-item__discount-price --offPercent"
                    }
                  >
                    <span>
                      {data.discountPercent
                        ? `${data.discountPercent}${i18n.discountPercentage}`
                        : data.discountAmount
                        ? `${currencySign}${data.discountAmount} ${i18n.off}`
                        : ""}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
      <div className="install-service-row">
        <div className="cart-blank-section">&nbsp;</div>
        {mode !== "share" && error?.isError && (
          <div className="col cart-item__stock-msg --error install-service">
            <span>{error?.msg}</span>
          </div>
        )}

        {mode !== "share" && !checkoutMode && (
          <div
            className="install-service-cta"
            aria-label={`${data.name} ${i18n.remove}`}
          >
            <span
              onClick={() =>
                isBundleChildItem
                  ? breakBundleItem(data.id)
                  : removeCartItem({
                      ...data,
                      quantity:
                        productData?.custom?.fields?.associatedServiceQty,
                      productData,
                    })
              }
            >
              Remove
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
export default InstallationServiceCart
